module.exports = __webpack_public_path__ + "static/smokewagon-cb29edeb0be2f7033185a843601f742b.jpg";